import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 58.35 77.804',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M57.49,57.507,45.35,43.757H50a3.453,3.453,0,0,0,3.158-1.985,3.35,3.35,0,0,0-.5-3.655L40.792,24.307h4.39a3.443,3.443,0,0,0,3.17-2.068,3.381,3.381,0,0,0-.644-3.659L30.951.728a2.5,2.5,0,0,0-3.544,0L10.65,18.579a3.384,3.384,0,0,0-.644,3.659,3.445,3.445,0,0,0,3.171,2.068h4.39L5.693,38.121a3.355,3.355,0,0,0-.5,3.653,3.452,3.452,0,0,0,3.158,1.983h4.654L.868,57.507a3.359,3.359,0,0,0-.541,3.686A3.524,3.524,0,0,0,3.52,63.207h20.8v3.715l-4.6,7.355A2.432,2.432,0,0,0,21.888,77.8H36.47a2.432,2.432,0,0,0,2.174-3.519l-4.6-7.355V63.207h20.8a3.524,3.524,0,0,0,3.193-2.013A3.359,3.359,0,0,0,57.49,57.507Z"
      transform="translate(-0.004 0.008)"
      fill={fill}
    />
  </svg>
);

export default SVG;
